"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconNamePropType = getIconNamePropType;

var _react = require("react");

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var propType;

function getIconNamePropType() {
  if (!propType) {
    // Optimization: Since prop types are only validated in dev mode, omit icon names in production.
    var iconNames = process.env.NODE_ENV === 'production' ? [] : require('icons/iconNames');
    propType = _react.PropTypes.oneOf(iconNames);
  }

  return (0, _createChainablePropType.default)(propType, 'iconName');
}